<template>
  <div class="eye-image">
    <EyeSVG ref="svg" />
  </div>
</template>

<script>
import EyeSVG from "@/assets/eye.svg"
import anime from 'animejs/lib/anime.es.js'

export default {
  name: "EyeImage",
  components: {
    EyeSVG
  },
  data() {
    return {
      onScreen: false,
      observer: null,
    }
  },
  mounted: function() {
    // const svg = this.$refs.svg

    const blink = {
      targets: '.eye-image clipPath ellipse',
      ry: [198.87, 1, 198.87],
      duration: 275,
      easing: 'easeInOutBounce',
    }
    // const dilate = {
    //   targets: '.eye-image .pupil',
    //   scale: [1.02, 1],
    //   duration: 500,
    //   easing: 'easeOutBack',
    // }

    const tl = anime.timeline({
      easing: 'easeInOutBounce',
      loop: true,
    });

    tl
      .add(blink, '+=5000')
      .add(blink)
      .add(blink, '+=4000')
      .add(blink, '+=6000')
  },
}
</script>

<style lang="scss" scoped>
  .eye-image {
    position: relative;

    * {
      transition: none;
      transform-origin: center;
    }

    svg {
      transition: none;
    }
  }
</style>
